const state = () => ({
    fieldsConfig: {}
})

const getters = {
    getFieldsConfig: state => state.fieldsConfig,
}

const mutations = {
    setFieldsConfig: (state, payload) => state.fieldsConfig = payload,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
